<template>
  <div>
    <PageHeader
      :image="DicasBannerImage"
      ariaLabel="Pessoas correndo"
      :minHeight="421"
      title="Percurso e Dicas"
    />
    <div class="percurso-page">
      <div class="container">
        <div class="row percurso-page__title">
          <div class="col-12 col-lg-11 offset-lg-1">
            Mapa do Percurso
          </div>
        </div>
        <map-box />
        <div class="row percurso-page__title">
          <div id="dicas"></div>
          <div class="col-12 col-lg-11 offset-lg-1">
            Dicas
          </div>
        </div>
        <div class="row percurso-page__subtitle">
          <div class="col-12 col-lg-11 offset-lg-1">
            Veja como caminhar com mais saúde e segurança com estas 13 dicas.
          </div>
        </div>
        <div class="row percurso-page__hints">
          <div class="col-12 col-lg-3 offset-lg-1">
            <hint-box number="1">
              A caminhada é um exercício que deve ser praticado com regularidade.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="2">
              Antes de iniciar um programa de atividades físicas, procure um médico para uma avaliação, principalmente da capacidade cardiorrespiratória.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="3">
              Procure fazer uma refeição leve antes de iniciar qualquer atividade física. Dê preferência para frutas e carboidratos. Evite praticar exercícios físicos em jejum e após a ingestão de alimentos gordurosos.
            </hint-box>
          </div>
          <div class="col-12 col-lg-6 offset-lg-1">
            <hint-box number="4">
              Evite ingerir bebidas alcoólicas, pelo menos 12 horas antes da prática de esportes e durante a caminhada, procure hidratar-se preferencialmente com soluções isotônicas em intervalos regulares. Evite a ingestão de grandes volumes de água de uma só vez, isto poderá lhe trazer mal estar.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="5">
              Abandone o hábito de fumar. O uso do cigarro favorece o aparecimento de várias doenças e limita sua atividade física.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1">
            <hint-box number="6">
              Procure dormir pelo menos 8 horas por noite.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="7">
              Use calçados e roupas adequadas e confortáveis para a caminhada.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="8">
              Use protetor solar com fator de proteção igual ou superior a 20, pelo menos 30 minutos antes da exposição solar, mesmo com tempo nublado.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1">
            <hint-box number="9">
              Evite os horários mais quentes. Use óculos com proteção contra os raios solares (UVA e UVB). Se preferir, use também boné ou viseira.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="10">
              Realize exercícios de alongamento e aquecimento antes da caminhada. Alongamentos após a atividade física também evitam dores e lesões futuras. É só fazer 4 séries de 20 segundos cada, antes e após a atividade física.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3">
            <hint-box number="11">
              Caso você faça uso contínuo de medicamentos como insulina, anticonvulsivantes, anti-hipertensivos, etc., não o interrompa para praticar esportes. Peça sempre orientações ao seu médico.
            </hint-box>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1">
            <hint-box number="12">
              Se você sentir estar no seu limite físico ou passar mal durante a caminhada, interrompa o exercício e peça ajuda.
            </hint-box>
          </div>
          <div class="col-12 col-lg-6">
            <hint-box number="13">
              Tenha sempre com você um documento de identidade, cartão com endereço e telefones de contato, além da carteira do plano de saúde, se possuir.
            </hint-box>
          </div>
        </div>
        <div class="row percurso-page__text">
          <div class="col-12 col-lg-10 offset-lg-1">
            A caminhada é um dos exercícios de maior importância para o organismo. Além de manter o corpo em forma sem muito esforço físico, ajuda a fortalecer os músculos e proporciona o bem-estar que tanto buscamos.
          </div>
        </div>
        <div class="row percurso-page__callback">
          <div class="col-12 col-lg-12">
            <!-- <router-link :to="{ name: 'inscrevase' }">
              <Button big>
                Inscreva-se aqui
              </Button>
            </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/PageHeader'
  import DicasBannerImage from '@/images/programacaoHomeEBannerDicas.jpg'
  import HintBox from '@/components/HintBox'
  import FooterBox from '@/components/FooterBox'
  import MapBox from '@/components/MapBox'
  import Button from '@/components/Button'

  export default {
    name: 'BannerRegulamento',
    components: {
      PageHeader,
      MapBox,
      FooterBox,
      HintBox,
      Button,
    },
    mounted() {
      const anchor = this.$router.currentRoute.hash
      this.$nextTick(() => {
        if (anchor && document.querySelector(anchor)) {
          setTimeout(function() {
            location.href = anchor
          }, 50)
        }
      })
    },
    data: () => ({
      DicasBannerImage,
    })
  }
</script>


<style lang="scss" scoped>
  .percurso-page
  {
    padding-top: 90px;

    background-color: #14191c;

    &__title
    {
      font-size: 40px;
      font-weight: bold;
      line-height: 40px;

      position: relative;
      z-index: 10;

      margin-bottom: 20px;

      color: #fff;
    }

    &__subtitle
    {
      font-weight: 17px;
      line-height: 25px;

      text-transform: uppercase;

      color: #fff;
    }

    &__hints,
    &__text,
    &__callback
    {
      padding: 50px 0;
    }

    &__text
    {
      font-size: 30px;
      line-height: 40px;

      color: #fff;
    }

    &__callback
    {
      text-align: center;
    }
  }
</style>
